var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation-UX-(New)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation_New-Update-(Desktop)",
    transform: "translate(-20.000000, -132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(19.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_team_2516237",
    transform: "translate(0.000000, 4.000000)",
    fill: "#bbb",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9915077,7.5 C13.0730564,7.5 14.7658479,5.818125 14.7658479,3.75 C14.7658479,1.681875 13.0724273,0 10.9915077,0 C8.91058817,0 7.21716753,1.681875 7.21716753,3.75 C7.21716753,5.818125 8.90995911,7.5 10.9915077,7.5 Z M10.9915077,1.25 C12.3792068,1.25 13.5077345,2.37125 13.5077345,3.75 C13.5077345,5.12875 12.3792068,6.25 10.9915077,6.25 C9.60380865,6.25 8.47528093,5.12875 8.47528093,3.75 C8.47528093,2.37125 9.60380865,1.25 10.9915077,1.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5966031,8.75 C19.1572928,8.75 20.4273582,7.488125 20.4273582,5.9375 C20.4273582,4.386875 19.1572928,3.125 17.5966031,3.125 C16.0359134,3.125 14.7658479,4.386875 14.7658479,5.9375 C14.7658479,7.488125 16.0359134,8.75 17.5966031,8.75 Z M17.5966031,4.375 C18.4640723,4.375 19.1692448,5.07625 19.1692448,5.9375 C19.1692448,6.79875 18.4634432,7.5 17.5966031,7.5 C16.729763,7.5 16.0239613,6.79875 16.0239613,5.9375 C16.0239613,5.07625 16.7291339,4.375 17.5966031,4.375 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5966031,10 C16.8228634,10 16.0617047,10.2025 15.3949046,10.585625 C15.343322,10.615 15.3062076,10.658125 15.2665771,10.698125 C14.2273754,9.5075 12.6981386,8.75 10.9915077,8.75 C9.28865125,8.75 7.76318875,9.504375 6.72398708,10.69 C6.68624367,10.653125 6.65290367,10.6125 6.60509536,10.585625 C5.93829526,10.2025 5.17713665,10 4.40339691,10 C1.97523804,10 0,11.9625 0,14.375 C0,14.72 0.281817402,15 0.629056701,15 C0.976296,15 1.2581134,14.72 1.2581134,14.375 C1.2581134,12.651875 2.66908758,11.25 4.40339691,11.25 C4.95570869,11.25 5.49984274,11.394375 5.9754096,11.6675 C5.98987791,11.67625 6.00686244,11.67625 6.02258885,11.683125 C5.58099105,12.48375 5.32999743,13.400625 5.32999743,14.375 C5.32999743,14.72 5.61181483,15 5.95905413,15 C6.30629343,15 6.58811083,14.72 6.58811083,14.375 C6.58811083,11.9625 8.56334887,10 10.9915077,10 C13.4196666,10 15.3949046,11.9625 15.3949046,14.375 C15.3949046,14.72 15.676722,15 16.0239613,15 C16.3712006,15 16.653018,14.72 16.653018,14.375 C16.653018,13.4025 16.4032825,12.486875 15.9635719,11.688125 C15.9837017,11.679375 16.0044606,11.67875 16.0239613,11.6675 C16.5001573,11.394375 17.0436623,11.25 17.5966031,11.25 C19.3309124,11.25 20.7418866,12.651875 20.7418866,14.375 C20.7418866,14.72 21.023704,15 21.3709433,15 C21.7181826,15 22,14.72 22,14.375 C22,11.9625 20.0241329,10 17.5966031,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40276785,3.125 C2.84207817,3.125 1.5720127,4.386875 1.5720127,5.9375 C1.5720127,7.488125 2.84207817,8.75 4.40276785,8.75 C5.96345752,8.75 7.233523,7.488125 7.233523,5.9375 C7.233523,4.386875 5.96345752,3.125 4.40276785,3.125 Z M4.40276785,7.5 C3.53529866,7.5 2.8301261,6.79875 2.8301261,5.9375 C2.8301261,5.07625 3.53592772,4.375 4.40276785,4.375 C5.26960798,4.375 5.9754096,5.07625 5.9754096,5.9375 C5.9754096,6.79875 5.27023704,7.5 4.40276785,7.5 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.81f6df935eff6ed5ba2f2a9a796f9493.svg";
export { ForwardRef as ReactComponent };